import React from 'react';

import { PopoverProps } from "antd";
import { OptionsButton } from "../Buttons";
import './style.scss';

interface Props {
  children: React.ReactNode;
  className?: string;
}

interface OptionsProps {
  options: any;
  placement?: PopoverProps['placement'];
  horizontal?: boolean;
}

interface PropsItem {
  children: React.ReactNode;
  className?: string;
  parent?: boolean;
  active?: boolean;
  image?: string;
  options?: OptionsProps;
}

const ListVertical = (props: Props) => {
  return (
    <div className={`v-list-vertical ${props.className || ''}`}>
      {props.children}
    </div>
  );
}

ListVertical.Item = (props: PropsItem) => {
  let className = `o-item ${props.className || ''}`;

  if (props.parent) {
    className += ' o-parent';
  }

  if (props.active) {
    className += ' active';
  }

  const Image = ({ url }: { url: string }) => (
    <div className='v-thumb-box'>
      <img src={url} alt='list-thumbnail' />
    </div>
  )

  return (
    <li className={className}>
      {props.image && <Image url={props.image} />}

      <div className='o-children'>{props.children}</div>

      {props.options && <OptionsButton {...props.options} />}
    </li>
  )
}

export default ListVertical;
